var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text spacer--padding--t--m spacer--padding--b--xl"},[_c('Grid',{attrs:{"col":{ default: 12, s: 6 }}},[_c('div',{staticClass:"title spacer--padding--b--m",domProps:{"innerHTML":_vm._s(_vm.data.title)}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.data.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }